import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';

import Button from 'Mui/Button';
import Typography from '@material-ui/core/Typography';

import { error, system900 } from 'Mui/styles/color';
import { below } from 'utils/breakpoint';

function PointJoin({ currentPoints, needPoints, isKKReducePointMode, onConfirm, onClose }) {
    const isPointsEnough = currentPoints >= needPoints;

    return (
        <>
            <div css={contentStyle}>
                <Typography variant="h6">
                    {i18n.t('label.own_point', { count: currentPoints })}
                </Typography>
                <Typography variant="h6">
                    {i18n.t('label.activity_needed_point', { count: needPoints })}
                </Typography>
                <Typography variant="h6">{i18n.t('label.activity_point_hint')}</Typography>
                {!isPointsEnough && (
                    <Typography variant="subtitle1" css={errroStyle}>
                        {i18n.t('label.point_not_enough')}
                    </Typography>
                )}
            </div>
            <div css={btnContainerStyle}>
                {isPointsEnough && (
                    <Button variant="contained" onClick={onConfirm} css={successBtnStyle}>
                        {i18n.t('label.confirm_pay_point_join')}
                    </Button>
                )}
                {!isPointsEnough && isKKReducePointMode && (
                    <a
                        href="https://kkpoints.kkbox.com/info"
                        target="_blank"
                        rel="noopener noreferrer"
                        css={linkStyle}
                    >
                        <Button variant="contained" css={successBtnStyle}>
                            {i18n.t('label.gain_point_now')}
                        </Button>
                    </a>
                )}
                <Button onClick={onClose} css={cancelBtnStyle}>
                    {i18n.t('btn.back')}
                </Button>
            </div>
        </>
    );
}

export default PointJoin;

const contentStyle = css`
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const btnContainerStyle = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
`;

const errroStyle = css`
    color: ${error.color};
`;

const successBtnStyle = css`
    background: ${system900.color};
    color: #fff;
    &:hover {
        background: rgba(85, 85, 85, 0.8);
    }
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;

const cancelBtnStyle = css`
    margin-top: 8px;
    width: 500px;
    ${below('xsm')} {
        width: 100%;
    }
`;

const linkStyle = css`
    text-decoration: none;
`;
